<template>
  <div id="app">
    <router-view></router-view>

  </div>
</template>

<script>

export default {
  name: 'App',
  mounted() {
    document.title = '写作技巧技术分享';
  }
}
</script>

<style>
</style>
